// LiveStreamPusherHandler.jsx
import React from 'react';
import PropTypes from 'prop-types';

import {
  PRESET_SD,
  ExclusivePrivateStatus as ExclusivePrivateStatusConstant,
} from '../resource/liveStreamConstants.js';

export class LiveStreamPusherHandler extends React.PureComponent {
  canSubscribePresenceStreamExclusive = () => {
    const {
      meId,
      exclusivePrivateStatus,
      exclusivePrivateBuyerId,
      isLivestreamModerator,
    } = this.props;
    const isExclusivePrivateBuyer =
      meId != null && meId === exclusivePrivateBuyerId;
    return (
      ExclusivePrivateStatusConstant.PERFORMING === exclusivePrivateStatus &&
      (isExclusivePrivateBuyer || isLivestreamModerator)
    );
  };
  componentDidMount() {
    const {
      streamId,
      pusherPreset,
      fundingId,
      meId,
      subscribeStreamChannel,
      subscribeStreamViewerChannel,
      subscribePresenceGoalChannel,
      shouldSubscribeStreamChannel,
      subscribePresenceStreamExclusive,
    } = this.props;
    if (this.canSubscribePresenceStreamExclusive()) {
      subscribePresenceStreamExclusive({
        streamId,
      });
    }
    if (shouldSubscribeStreamChannel) {
      subscribeStreamChannel({
        streamId,
      });
    }
    subscribeStreamViewerChannel({
      streamId,
      preset: pusherPreset,
    });
    subscribePresenceGoalChannel({
      goalId: fundingId,
      userId: meId,
    });
  }
  componentDidUpdate(prevProps) {
    const {
      streamId,
      pusherPreset,
      meId,
      fundingId,
      shouldSubscribeStreamChannel,
      subscribeStreamViewerChannel,
      unsubscribeStreamViewerChannel,
      subscribePresenceGoalChannel,
      unsubscribePresenceGoalChannel,
      unsubscribeStreamChannel,
      exclusivePrivateStatus,
      exclusivePrivateBuyerId,
      isLivestreamModerator,
      subscribePresenceStreamExclusive,
      unsubscribePresenceStreamExclusive,
    } = this.props;
    if (
      meId !== prevProps.meId ||
      exclusivePrivateBuyerId !== prevProps.exclusivePrivateBuyerId ||
      isLivestreamModerator !== prevProps.isLivestreamModerator ||
      exclusivePrivateStatus !== prevProps.exclusivePrivateStatus
    ) {
      if (this.canSubscribePresenceStreamExclusive()) {
        subscribePresenceStreamExclusive({
          streamId,
        });
      } else {
        unsubscribePresenceStreamExclusive({
          streamId,
        });
      }
    }
    if (prevProps.pusherPreset !== pusherPreset) {
      unsubscribeStreamViewerChannel({
        streamId,
        preset: prevProps.pusherPreset,
      });
      subscribeStreamViewerChannel({
        streamId,
        preset: pusherPreset,
      });
    }
    if (meId !== prevProps.meId) {
      unsubscribePresenceGoalChannel({
        goalId: fundingId,
        userId: prevProps.meId,
      });
      subscribeStreamViewerChannel({
        streamId,
        preset: pusherPreset,
      });
      subscribePresenceGoalChannel({
        userId: meId,
        goalId: fundingId,
      });
    }
    if (fundingId !== prevProps.fundingId) {
      unsubscribePresenceGoalChannel({
        userId: meId,
        goalId: prevProps.fundingId,
      });
      subscribePresenceGoalChannel({
        userId: meId,
        goalId: fundingId,
      });
    }
    if (
      !shouldSubscribeStreamChannel &&
      shouldSubscribeStreamChannel !== prevProps.shouldSubscribeStreamChannel
    ) {
      unsubscribeStreamChannel({ streamId });
    }
  }
  componentWillUnmount() {
    const {
      streamId,
      meId,
      fundingId,
      pusherPreset,
      unsubscribeStreamViewerChannel,
      unsubscribeStreamChannel,
      unsubscribePresenceGoalChannel,
      unsubscribePresenceStreamExclusive,
    } = this.props;
    unsubscribePresenceStreamExclusive({
      streamId,
    });
    unsubscribeStreamChannel({
      streamId,
    });
    unsubscribeStreamViewerChannel({
      streamId,
      preset: pusherPreset,
    });
    unsubscribePresenceGoalChannel({
      userId: meId,
      goalId: fundingId,
    });
  }
  render() {
    return null;
  }
}

LiveStreamPusherHandler.propTypes = {
  streamId: PropTypes.string,
  pusherPreset: PropTypes.string,
  meId: PropTypes.string,
  fundingId: PropTypes.string,
  subscribeStreamChannel: PropTypes.func,
  subscribeStreamViewerChannel: PropTypes.func,
  unsubscribeStreamChannel: PropTypes.func,
  unsubscribeStreamViewerChannel: PropTypes.func,
  subscribePresenceGoalChannel: PropTypes.func,
  unsubscribePresenceGoalChannel: PropTypes.func,
  subscribePresenceStreamExclusive: PropTypes.func,
  unsubscribePresenceStreamExclusive: PropTypes.func,
  shouldSubscribeStreamChannel: PropTypes.bool,
  exclusivePrivateStatus: PropTypes.string,
  exclusivePrivateBuyerId: PropTypes.string,
  isLivestreamModerator: PropTypes.bool,
};

LiveStreamPusherHandler.defaultProps = {
  streamId: null,
  pusherPreset: PRESET_SD,
  meId: null,
  fundingId: null,
  subscribeStreamChannel: () => null,
  subscribeStreamViewerChannel: () => null,
  unsubscribeStreamChannel: () => null,
  unsubscribeStreamViewerChannel: () => null,
  subscribePresenceGoalChannel: () => null,
  unsubscribePresenceGoalChannel: () => null,
  subscribePresenceStreamExclusive: () => null,
  unsubscribePresenceStreamExclusive: () => null,
  shouldSubscribeStreamChannel: true,
  exclusivePrivateStatus: null,
  exclusivePrivateBuyerId: null,
  isLivestreamModerator: false,
};

export default LiveStreamPusherHandler;
